module.exports = __webpack_public_path__ + "img/ill_community.7ddc57e6.png";